<button (click)="click.next(); $event.stopPropagation()"
    class="flex flex-col items-center flex-auto ajin-card w-full gap-4 px-2 py-2 text-default"

    [ngClass]="{'{{color}}': color, 'bg-input-hover': !color}"

     [disabled]="disabled" [class.disabled]="disabled">
    <mat-icon   [svgIcon]="icon" *ngIf="icon"> </mat-icon>
    <span class="flex flex-auto" *ngIf="label"> {{label}}</span>

</button>
